//导入
import {
   list,
   wxcode,
   verify,
   history,
   deleteHistory,
   addWhite,
   whiteList,
   deletewhiteList,
   DataRole,
   getToken,
   getById,
   getvehicle,
   getHistory,
   Login,
   BySM2,
   addLongWhite,
   whiteListLong,
   deleteLongwhiteList,
   isAddLongWhite,
} from './api';
//导出
const request = {
   list,
   wxcode,
   verify,
   history,
   deleteHistory,
   addWhite,
   whiteList,
   deletewhiteList,
   DataRole,
   getToken,
   getById,
   getvehicle,
   getHistory,
   Login,
   BySM2,
   addLongWhite,
   whiteListLong,
   deleteLongwhiteList,
   isAddLongWhite,
};

export default request;